import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import ExamDetails from '../Modules/ExamDetails';
import Incidents from '../Modules/Incidents';

const IncidentReport = observer(class IncidentReport extends React.Component {
  componentWillMount() {
    if(typeof this.props.exam === 'undefined') {
      const examSid = this.props.routing.location.query.eventsFor;
      this.props.store.ExamStore.getExam(examSid);
    }
  }

  render() {
    const { translation } = this.props;

    let exam = null;

    if(typeof this.props.exam === 'undefined') {
      exam = this.props.store.ExamStore.exam;
    } else {
      exam = this.props.exam;
    }

    return(
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>

        <div className="wrap">
          <ExamDetails exam={exam} {...this.props} />
          <Incidents {...this.props} />
        </div>
      </div>
    )
  }
})

export default translate('IncidentReport')(IncidentReport);


// WEBPACK FOOTER //
// ./src/app/components/Drawer/IncidentReport.js